import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 防止不跳转页面，只修改路由参数报错
const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.replace = function (location) {
  return originalReplace.call(this, location).catch(err => err)
}

const routes = [
  //
  {
    path: '/',
    name: 'Home',
    meta: {
      title: '首页',
      deepth: 0.5,
      keepAlive: true, //需要被缓存
      // scrollTop: 0,
    },
    // redirect: '/List',
    component: () => import('@/views/Home.vue')
  },
  //
  {
    path: '/List',
    name: 'List',
    meta: {
      title: '课题列表',
      deepth: 1,
      keepAlive: true, //需要被缓存
      scrollTop: 0
    },
    component: () => import('@/views/List/index.vue')
  },

  //
  {
    path: '/Detail',
    name: 'Detail',
    meta: {
      title: '',
      deepth: 2
    },
    component: () => import('@/views/Detail.vue')
  },
  //
  {
    path: '/Disclaimers',
    name: 'Disclaimers',
    meta: {
      title: 'Disclaimers'
    },
    component: () => import('@/views/Disclaimers.vue')
  },

  {
    path: '/schooldetail',
    name: 'SchoolDetail',
    meta: {
      title: ''
    },
    component: () => import('@/views/SchoolDetail.vue')
  },

  //
  {
    path: '/CalendarDetail',
    name: 'CalendarDetail',
    meta: {
      title: ''
    },
    component: () => import('@/views/CalendarDetail.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: () => import('@/views/404.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
